export default class MegaNav {
  constructor() {
    this.activeClass = 'is-active';
    this.parentClass = 'js-mega-nav_parent';
    this.triggerClass = 'js-mega-nav_trigger';
    this.targetClass = 'js-mega-nav_target';
    this.breakpointQuery = window.matchMedia('(min-width: 768px)');
    this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, [tabindex="0"], [contenteditable], iframe';
    this.parents = document.querySelectorAll('.' + this.parentClass);

    if(this.parents.length > 0) {
      this.init();
    }
  }

  isDesktopLayout() {
    return this.breakpointQuery.matches;
  }

  isHoverInteraction() {
    return this.isDesktopLayout() && this.hoverQuery.matches;
  }

  isTabletInteraction() {
    return this.isDesktopLayout() && !this.hoverQuery.matches;
  }

  init() {
    this.parents.forEach((parent, index) => {
      const trigger = parent.querySelector('.' + this.triggerClass);
      const target = parent.querySelector('.' + this.targetClass);
      if(!trigger || !target) {
        return;
      }

      this.setAriaRelation(trigger, target, index);

      parent.addEventListener('mouseenter', () => {
        if(this.isHoverInteraction()) {
          this.open(trigger, target, true);
        }
      });

      parent.addEventListener('mouseleave', () => {
        if(this.isHoverInteraction()) {
          this.close(trigger, target, true);
        }
      });

      parent.addEventListener('focusin', () => {
        if(this.isHoverInteraction()) {
          this.open(trigger, target, true);
        }
      });

      parent.addEventListener('focusout', e => {
        if(this.isDesktopLayout() && !parent.contains(e.relatedTarget)) {
          this.close(trigger, target, true);
        }
      });

      trigger.addEventListener('click', e => {
        if(this.isHoverInteraction()) {
          if(e.pointerType === 'mouse') {
            return;
          }

          e.preventDefault();
          if(trigger.classList.contains(this.activeClass)) {
            this.close(trigger, target, true);
          } else {
            this.open(trigger, target, true);
          }
          return;
        }

        if(this.isDesktopLayout()) {
          e.preventDefault();
          e.stopPropagation();
          if(trigger.classList.contains(this.activeClass)) {
            this.close(trigger, target, true);
          } else {
            this.open(trigger, target, true);
          }
          return;
        }

        if(trigger.classList.contains(this.activeClass)) {
          this.close(trigger, target, false);
        } else {
          this.open(trigger, target, false);
        }
      }, true);

      trigger.addEventListener('keydown', e => {
        if(this.isDesktopLayout() && e.key === 'Escape') {
          e.preventDefault();
          this.close(trigger, target, true);
          trigger.focus();
        }
      });

      target.addEventListener('keydown', e => {
        if(this.isDesktopLayout() && e.key === 'Escape') {
          e.preventDefault();
          this.close(trigger, target, true);
          trigger.focus();
        }
      });
    });

    document.addEventListener('pointerdown', (e) => {
      if(!this.isTabletInteraction() || !this.hasOpenMenu()) {
        return;
      }

      if(!this.isInsideOpenMegaNav(e.target)) {
        this.closeAllTabletMenus();
      }
    }, true);

    this.breakpointQuery.addEventListener('change', () => {
      this.syncByViewport();
    });

    this.hoverQuery.addEventListener('change', () => {
      this.syncByViewport();
    });

    this.syncByViewport();
  }

  setAriaRelation(trigger, target, index) {
    if(!target.id) {
      target.id = 'js-mega-nav-panel-' + index;
    }
    trigger.setAttribute('aria-controls', target.id);
  }

  hasOpenMenu() {
    return Array.from(this.parents).some((parent) => {
      const trigger = parent.querySelector('.' + this.triggerClass);
      return trigger && trigger.classList.contains(this.activeClass);
    });
  }

  isInsideOpenMegaNav(target) {
    if(!target) {
      return false;
    }

    return Array.from(this.parents).some((parent) => {
      const trigger = parent.querySelector('.' + this.triggerClass);
      if(!trigger || !trigger.classList.contains(this.activeClass)) {
        return false;
      }

      return parent.contains(target);
    });
  }

  closeAllTabletMenus() {
    this.parents.forEach((parent) => {
      const trigger = parent.querySelector('.' + this.triggerClass);
      const target = parent.querySelector('.' + this.targetClass);
      if(!trigger || !target || !trigger.classList.contains(this.activeClass)) {
        return;
      }

      this.close(trigger, target, true);
    });
  }

  syncByViewport() {
    const isDesktop = this.isDesktopLayout();
    this.parents.forEach(parent => {
      const trigger = parent.querySelector('.' + this.triggerClass);
      const target = parent.querySelector('.' + this.targetClass);
      if(!trigger || !target) {
        return;
      }

      this.close(trigger, target, isDesktop);
    });
  }

  closeOthers(activeTrigger) {
    this.parents.forEach((parent) => {
      const trigger = parent.querySelector('.' + this.triggerClass);
      const target = parent.querySelector('.' + this.targetClass);
      if(!trigger || !target || trigger === activeTrigger) {
        return;
      }

      if(trigger.classList.contains(this.activeClass)) {
        this.close(trigger, target, true);
      }
    });
  }

  open(trigger, target, isDesktop) {
    if(this.isTabletInteraction()) {
      this.closeOthers(trigger);
    }

    trigger.classList.add(this.activeClass);
    target.classList.add(this.activeClass);
    target.style.maxHeight = isDesktop ? '' : target.scrollHeight + 'px';
    trigger.setAttribute('aria-expanded', 'true');
    target.setAttribute('aria-hidden', 'false');
    this.setFocusable(target, true);
  }

  close(trigger, target, isDesktop) {
    trigger.classList.remove(this.activeClass);
    target.classList.remove(this.activeClass);
    target.style.maxHeight = isDesktop ? '' : 0;
    trigger.setAttribute('aria-expanded', 'false');
    target.setAttribute('aria-hidden', 'true');
    this.setFocusable(target, false);
  }

  setFocusable(target, isFocusable) {
    const focusableElements = target.querySelectorAll(this.focusableElementsString);
    focusableElements.forEach(el => {
      el.setAttribute('tabindex', isFocusable ? 0 : -1);
    });
  }
}
